import React from 'react';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { SellingPoints } from './components/SellingPoints';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Benefits } from './components/Benefits';
import { Content } from './components/Content';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Results } from './components/Results';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen bg-palomitas-cream font-sans selection:bg-palomitas-gold selection:text-white" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <SellingPoints data-id="element-3" />
      <Problem data-id="element-4" />
      <Solution data-id="element-5" />
      <Benefits data-id="element-6" />
      <Content data-id="element-7" />
      <Gallery data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Results data-id="element-10" />
      <Offer data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FinalCTA data-id="element-13" />

      {/* Simple Footer */}
      <footer className="bg-palomitas-dark border-t border-white/10 py-8 text-center text-palomitas-beige/60 text-sm" data-id="element-14">
        <div className="container mx-auto px-4" data-id="element-15">
          <p data-id="element-16">
            © {new Date().getFullYear()} Palomitas Gourmet. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs opacity-70" data-id="element-17">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}